module.exports = __webpack_public_path__ + "img/sendInvitationLinkEN.a8c02c7d.svg";